import { Bell } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Logo } from "@/components/layout/Logo";
import { SidebarTrigger, useSidebar } from "@/components/ui/sidebar";

interface DashboardTopNavProps {
  role: "teacher" | "student";
}

export function DashboardTopNav({ role }: DashboardTopNavProps) {
  const navigate = useNavigate();
  const { isMobile } = useSidebar();
  const bellPath = role === "teacher" ? "/teacher-inquiries" : "/my-inquiries";

  return (
    <header className="fixed top-0 left-0 right-0 z-50 h-14 bg-background/90 backdrop-blur-xl border-b border-border/60 flex items-center px-4 gap-2 sm:gap-3 shadow-sm">
      {/* Full wordmark on wider screens; icon-only below sm so it doesn't crowd out
          the notification bell and hamburger on narrow phones. */}
      <div className="hidden sm:block shrink-0">
        <Logo size="md" />
      </div>
      <div className="sm:hidden shrink-0">
        <Logo size="md" iconOnly />
      </div>
      <div className="flex-1" />
      <button
        onClick={() => navigate(bellPath)}
        className="w-10 h-10 flex items-center justify-center rounded-xl text-indigo-500 hover:text-indigo-700 hover:bg-indigo-50 active:bg-indigo-100 active:scale-95 transition-all shrink-0"
        aria-label="Notifications"
      >
        <Bell className="w-5 h-5" />
      </button>
      {/* Mobile only: the sidebar is an off-canvas sheet with no edge to dock to while
          closed, so the opener has to live here. On desktop the trigger is rendered
          inside the Sidebar itself (TeacherSidebar/StudentSidebar), next to "Menu". */}
      {isMobile && <SidebarTrigger className="w-10 h-10 active:scale-95 transition-transform shrink-0" />}
    </header>
  );
}
